import GeografiaView from '../GeografiaView.vue'
import CountryList from '../Pages/CountryList.vue'
import CityList from '../Pages/CityList.vue'
import AirportList from '../Pages/AirportList.vue'

const routes = [
  {
    path: '/geografia',
    component: GeografiaView,
    name: 'geografia',
    children: [
      {
        path: 'paises',
        name: 'geografia-country-list',
        component: CountryList,
      },
      {
        path: 'ciudades',
        name: 'geografia-city-list',
        component: CityList,
      },
      {
        path: 'aeropuertos',
        name: 'geografia-airport-list',
        component: AirportList,
      },
    ],
  },
]

export default routes
